// 2026-09-27：商品查询提示补充款号，同步已有中英文翻译键。
export default {
  manufacturers: '成衣生产厂家',
    rights: '角色权限',    
    coupon: '优惠券',
    images: '客户的杂图',
    datainit: '分店初始数据',
    templatedetails:'系统集成模板详情',
    sharedimgs: '共享版型图片',
    orgdetails: '分店详情',
    productDetails: '版型详情',
    clothSize: '服装尺码',
    // 2026-08-24：补齐报表目录，并区分首页轮播与全站消息。
    report: '报表设计',
    platformTitle: '平台管理',
    platform:{
      // 2026-09-17：平台栏目独立命名，分店保留原分店清单与轮播名称。
      merchants: '入驻商家',
      platforminfo: '平台信息',
      accounts: '平台账号',
      defaultFunctions:'新店角色权限',
      // 2026-08-24：客户类型、VIP角色、价格及多端功能统一在一个总控入口维护。
      orgrights:'VIP角色总控',
      feedback: '客户反馈',
    },
    ordersTitle: '订单管理',
    orders: {
      bokesOrder: '电子版订单',
      clothsOrders: '成衣现货订单',
      decorationOders: '饰品订单',
      fabricsOrder: '面料订单',
      accessoriesOrder: '辅料订单',
      physicalBokes: '纸质版订单',
      physicalPrinting: '纸质版打印',
      tailoredOrders: '量体订单',
      tailoredBokes: '来图制版订单',
      tailoredCloths: '成衣定制订单',
      clothsOrder: '成衣现货订单',
      tailoredMade: '定制版型订单',
      tailoredMadeDetail:'量体定制订单详情',
      videoTeching: '教学课程订单',
      takeOrders:'成衣接单',
      upgration:'会员升级订单',
      autoscaleOrders:'智能量体订单'
    },
    customersTitle:'客户管理',
    customers:{
      customers:'客户管理',
      levels:'会员等级',
      notes:'优惠券',
      extention:'会员续期审核',
    },
    auditedTitle:'审核管理',
    audited:{
      ref:'版型引用审核',
      shared:'版型共享审核',
      settings:'审核设置',
      fabrics:'服装面料审核',
      accessories:'服装辅料审核',
      decorations:'服装饰品审核',
      // 2026-08-10：版型审核与成衣/成衣定制审核拆分为两个菜单入口。
      bokes:'版型审核',
      cloths:'成衣定制审核',
      retailCloths:'成衣现货审核',
      upShare:'平台售卖审核'
    },
    productsTitle:'商品管理',
    products: {
      bokes: '版型管理',
      branchProducts:'版型管理',
      cloths: '成衣管理',
      clothDetails: '成衣明细',
      parentSharedprds:'平台商品',
      upsharedProducts:'分店商品平台售卖',
      fabrics: '面料管理',
      upshare:'分店上平台',
      fabricDetails:'面料详情',
      accessories:'辅料管理',
      decorationDetails:'饰品详情',
      accessoryDetails:'辅料详情',
      decoration:'饰品管理',
      sharingFromOther:'分店商品',
      binding:'批量绑定',
      accessoriesDetails:'辅料详情'
    },
    systemTitle: '系统设置',
    system: {
      siteNotifications: '全站通知',
      clothCategory: '商品类别',
      clothStyle: '服装风格',
      clothSize: '服装尺码',
      productUnit: '商品单位',
      clothSizeViewer: '服装尺码详情',
      videos:'帮助视频',
      settings:'系统参数设置',
      // 2026-09-22：新增可配置的功能用途与演示视频菜单。
      functionGuides:'系统功能设置',
      operationLogs:'操作日志',
      fabricCategories:'服装分类',
      banner:'首页轮播管理',
      messages:'全站消息',
      clothSizeTemplate:'尺码模板',
      depositeSettings:'账户充值设置',
      course:'教学视频',
      videoCategory:'视频分类'
    },
    inventoryTitle:'库存管理',
    inventory:{
      storage:'商品库存',
      instore:'入库详情',
      outstore:'出库详情',
    },
    financialTitle:'财务管理',
    financial:{
      recharge:'会员购买记录',
      myaccount:'资金账户',
      accountStatements:'流水记录',
      withdrawal:'资金提现',
      depositeRecords:'账户充值记录',
      depositeHistories:'账户充值设置'
    },
    '新增':'新增','启用':'启用','禁用':'禁用',
    '您确定要重置该机构的管理员密码吗？':'您确定要重置该机构的管理员密码吗？',
    '确认重置':'确认重置','重置密码':'重置密码',
    '接收':'接收','不收':'不收','不可操作':'不可操作',
    '新增账号':'新增账号',
    '修改管理员密码':'修改管理员密码',
    '登录名:':'登录名:','用户名:':'用户名:','联系电话:':'联系电话:',
    '登录密码:':'登录密码:','账户角色:':'账户角色:',
    '原始密码:':'原始密码:','新密码:':'新密码:','验证码:':'验证码:',
    '请录入账号登录名!':'请录入账号登录名!','录入登录名':'录入登录名',
    '请录入录入用户名!':'请录入录入用户名!','录入用户名':'录入用户名',
    '请录入联系电话!':'请录入联系电话!','录入联系电话':'录入联系电话',
    '请录入录入密码!':'请录入录入密码!','录入密码':'录入密码',
    '请选择账户角色!':'请选择账户角色!',
    '请录入原始密码!':'请录入原始密码!',
    '请录入短信验证码!':'请录入短信验证码!',
    '获取验证码':'获取验证码',
    '设置成功':'设置成功','发送成功':'发送成功',
    '密码已重置为123456':'密码已重置为123456',
    '请录入新密码!':'请录入新密码!',
    '密码至少6位，且包含字母与数字。':'密码至少6位，且包含字母与数字。',
    '原始密码不正确。':'原始密码不正确。','密码修改成功。':'密码修改成功。',
    '账号添加成功。':'账号添加成功。','账号添加失败：':'账号添加失败：',
    '账号修改成功。':'账号修改成功。','账号修改失败：':'账号修改失败：',
    '版型审核':'版型审核','面料审核':'面料审核','饰品审核':'饰品审核',
    '系统添加':'系统添加','管理员添加':'管理员添加',
    '图标':'图标','手机号码':'手机号码',
    '接收订单消息':'接收订单消息','接收审核消息':'接收审核消息',
    '角色':'角色','账号来源':'账号来源',
    '创建时间':'创建时间','最后登录时间':'最后登录时间',
    '秒后重新获取':'秒后重新获取',
    '登录名、手机号码、用户名':'登录名、手机号码、用户名',
    '雨滴':'雨滴',
    '修改了超级管理员密码':'修改了超级管理员密码',
    '个人信息':'个人信息','更新图标':'更新图标','个人资料':'个人资料',
    '登录名':'登录名','用户名':'用户名','手机号':'手机号','登录时间':'登录时间',
    '所属机构':'所属机构','机构类型':'机构类型','编辑个人信息':'编辑个人信息',
    '请输入昵称!':'请输入昵称!','请输入手机号!':'请输入手机号!',
    '所属机构:':'所属机构:','保存更改':'保存更改','机构信息':'机构信息',
    'LOGO白:':'LOGO白:','LOGO黑:':'LOGO黑:','客服链接:':'客服链接:',
    '机构全称:':'机构全称:','请输入机构全称!':'请输入机构全称!',
    '网站地址:':'网站地址:','机构简称:':'机构简称:','请输入机构简称!':'请输入机构简称!',
    '营业执照号:':'营业执照号:','请输入营业执照号!':'请输入营业执照号!',
    '营业执照:':'营业执照:','机构所在地:':'机构所在地:','请输入机构所在地!':'请输入机构所在地!',
    '机构责任人:':'机构责任人:','请输入机构责任人!':'请输入机构责任人!',
    '责任人电话:':'责任人电话:','请输入责任人电话!':'请输入责任人电话!',
    '责任人证件号:':'责任人证件号:','请输入责任人身份证号!':'请输入责任人身份证号!',
    '注册类型:':'注册类型:','微信子商户号:':'微信子商户号:','微信APPID:':'微信APPID:',
    '您确定要删除该配置吗，删除后将会影响系统正常支付？':'您确定要删除该配置吗，删除后将会影响系统正常支付？',
    '未配置':'未配置','扫码绑定打单员':'扫码绑定打单员',
    '首页设置':'首页设置','首页标题:':'首页标题:','请输入首页标题!':'请输入首页标题!',
    '首页描述:':'首页描述:','请输入首页描述!':'请输入首页描述!',
    '首页图片:':'首页图片:','绑定发货物流':'绑定发货物流',
    '绑定新物流公司':'绑定新物流公司','微信支付':'微信支付',
    '分账账户':'分账账户','开通微信支付':'开通微信支付',
    '请输入微信子商户号!':'请输入微信子商户号!','请输入微信APPID!':'请输入微信APPID!',
    '绑定物流公司':'绑定物流公司','物流公司:':'物流公司:','请选择物流公司!':'请选择物流公司!',
    '请选择物流公司':'请选择物流公司','物流账号:':'物流账号:','请录入物流账号!':'请录入物流账号!',
    '请录入物流账号':'请录入物流账号','绑定密码:':'绑定密码:',
    '绑定失败：':'绑定失败：',
    '解除绑定失败：':'解除绑定失败：','解除绑定成功':'解除绑定成功',
    '代码':'代码','附加码':'附加码','添加时间':'添加时间',
    '域名已存在':'域名已存在',
    '图片尺寸太小，不符合要求，至少50*50，且长宽比为1:1':'图片尺寸太小，不符合要求，至少50*50，且长宽比为1:1',
    '图片尺寸太大，不符合要求，宽高不能超过800*800，且长宽比为1:1':'图片尺寸太大，不符合要求，宽高不能超过800*800，且长宽比为1:1',
    '编辑个人账户信息':'编辑个人账户信息','保存失败，手机号码可能已使用！':'保存失败，手机号码可能已使用！',
    '请录入正确的域名地址，不包含http/https,例demo':'请录入正确的域名地址，不包含http/https,例demo',
    '更新成功':'更新成功','更新失败，请稍后再次尝试。':'更新失败，请稍后再次尝试。',
    'LOGO图片不符合要求,请重新选择。':'LOGO图片不符合要求,请重新选择。',
    '编辑机构信息':'编辑机构信息','保存成功':'保存成功',
    '企业':'企业','个人':'个人',
    '请输入客户姓名、手机号码开始查询':'请输入客户姓名、手机号码开始查询','客户类别':'客户类别',
    '会员级别':'会员级别','导出号码':'导出号码','个':'个',
    '新增会员':'新增会员','会员昵称:':'会员昵称:','请录入会员昵称!':'请录入会员昵称!',
    // 2026-10-17：同步新增客户空密码由后端随机生成的提示，原账号重置说明保持不变。
    '密码:':'密码:','未填写时自动生成随机密码':'未填写时自动生成随机密码',
    '手机号码:':'手机号码:','会员等级:':'会员等级:','会员长度':'会员长度','会员长度:':'会员长度:',
    '会员续期':'会员续期','续期长度:':'续期长度:','请选择续期长度!':'请选择续期长度!',
    '一个月':'一个月','三个月':'三个月','六个月':'六个月','一年':'一年','两年':'两年','三年':'三年',
    '自定义':'自定义','续期长度':'续期长度','到期时间:':'到期时间:','请选择到期截止时间!':'请选择到期截止时间!',
    '续期方式:':'续期方式:','请选择续期方式!':'请选择续期方式!',
    '对公汇款购买升级':'对公汇款购买升级','会员延期':'会员延期','其它':'其它','续期方式':'续期方式',
    '备注:':'备注:','续期备注':'续期备注','手动续期':'手动续期',
    '续版数量:':'续版数量:','请录入续版数量!':'请录入续版数量!',
    '支付金额:':'支付金额:','支付金额!':'支付金额!','续期时长:':'续期时长:','请选择续期长度':'请选择续期长度',
    '截止时间:':'截止时间:','请录入过期结止时间!':'请录入过期结止时间!',
    '手动延期':'手动延期','对公转账':'对公转账','线下转账':'线下转账',
    '您确定要删除这个客户吗？删除后不可恢复！':'您确定要删除这个客户吗？删除后不可恢复！',
    '发券':'发券','退卡':'退卡','你确定要':'你确定要','该账号吗？':'该账号吗？',
    '你确定要重置该账号密码吗？默认密码为123456':'你确定要重置该账号密码吗？默认密码为123456',
    '会员备注':'会员备注','更新备注':'更新备注','会员续期记录':'会员续期记录',
    '序号':'序号','时长':'时长','续期时间':'续期时间','操作员':'操作员',
    '个月':'个月','驳回:':'驳回:','续期通过':'续期通过','待支付':'待支付','天':'天',
    '您确定将当前账号解除黑名单吗？':'您确定将当前账号解除黑名单吗？',
    '您确定将当前账号拉入黑名单吗？':'您确定将当前账号拉入黑名单吗？',
    '充值':'充值','消费':'消费','退费':'退费',
    '变更会员级别':'变更会员级别','请选择一个会员级别!':'请选择一个会员级别!',
    '从一般会员升级为会员，过期日期为当天，请及时为会员续期。':'从一般会员升级为会员，过期日期为当天，请及时为会员续期。',
    '储值账户退款':'储值账户退款','账户本金':'账户本金','请录入退款金额!':'请录入退款金额!',
    '剩余赠额':'剩余赠额','已用赠额':'已用赠额','实退金额':'实退金额',
    '退款说明':'退款说明','请录入退款说明!':'请录入退款说明!','确定退卡':'确定退卡',
    '下载限制':'下载限制','单日下载限制:':'单日下载限制:','单日最大下载限制数量!':'单日最大下载限制数量!',
    '失效日期:':'失效日期:','请录入失效日期!':'请录入失效日期!',
    '失效时间:':'失效时间:','请录入失效时间!':'请录入失效时间!','说明':'说明',
    '1、限制会员单日下载电子版型数量。':'1、限制会员单日下载电子版型数量。',
    '2、为0，此设置不限制。':'2、为0，此设置不限制。',
    '3、不为0且在有限时间内，会限制。':'3、不为0且在有限时间内，会限制。',
    '4、该限制优先于全局限制。':'4、该限制优先于全局限制。',
    '发放优惠券':'发放优惠券','券名称:':'券名称:',
    // 2026-09-17：普通身份统一显示普通用户，保留旧翻译键兼容已有调用。
    '普通会员':'普通用户','普通用户':'普通用户','3个月':'3个月','6个月':'6个月','12个月':'12个月','终身':'终身',
    '客户充值/消费明细':'客户充值/消费明细','订单号':'订单号','充值金额':'充值金额',
    '赠送金额':'赠送金额','充值时间':'充值时间','类型':'类型',
    '下载余量':'下载余量','账户余额':'账户余额','会员过期时间':'会员过期时间',
    '过期天数':'过期天数','备注':'备注','黑名单':'黑名单',
    '1个月':'1个月','2个月':'2个月','半年':'半年','二年':'二年','四年':'四年','五年':'五年',
    '未过期':'未过期','已过期':'已过期','30天内过期':'30天内过期','已禁用':'已禁用','储值用户':'储值用户',
    '实退金额不能小于0!':'实退金额不能小于0!',
    '发放成功':'发放成功','当前客户不符合该券的发放要求，发放失败！':'当前客户不符合该券的发放要求，发放失败！',
    '请选择需要发放的优惠券！':'请选择需要发放的优惠券！','备注更新成功':'备注更新成功',
    '本金':'本金','已使用赠额':'已使用赠额','实退':'实退',
    '退卡成功':'退卡成功','其它会员':'其它会员',
    '新增客户:':'新增客户:','客户新增成功':'客户新增成功',
    '账号：':'账号：','的密码':'的密码','重置密码成功！':'重置密码成功！',
    '当前客户有未完成的会员续期单据，请完成后再发起续期。':'当前客户有未完成的会员续期单据，请完成后再发起续期。',
    '续期成功':'续期成功','续期会员':'续期会员','的有效期':'的有效期',
    '设置账号的下载限制':'设置账号的下载限制',
    '最后登录时间倒序':'最后登录时间倒序','会员过期时间倒序':'会员过期时间倒序','会员创建时间倒序':'会员创建时间倒序',
    '面料折扣': '面料折扣',
    '购买时长': '购买时长',
    '购买金额': '购买金额',
    '店主购买金额': '店主购买金额',
    '所衣折扣': '所衣折扣',
    '饰品折扣': '饰品折扣',
    '辅料折扣': '辅料折扣',
    '可下载数量': '可下载数量',
    '等级名称': '等级名称',
    '成衣定制折扣': '成衣定制折扣',
    '成衣现货折扣': '成衣现货折扣',
    '版型下载数量': '版型下载数量',
    '购买时长(月)': '购买时长(月)',
    '终端客户购买金额': '终端客户购买金额',
    '编辑会员等级': '编辑会员等级',
    '的数据': '的数据',
    '保存成功！': '保存成功！',
    '优惠券设置': '优惠券设置',
    '请录入券名称!': '请录入券名称!',
    '请录入券名称，如双十一活动券。': '请录入券名称，如双十一活动券。',
    '券类型:': '券类型:',
    '请选择券类型!': '请选择券类型!',
    '推荐用户券': '推荐用户券',
    '活动券': '活动券',
    '用户券': '用户券',
    '核销对象:': '核销对象:',
    '请录入核销对象!': '请录入核销对象!',
    '受众范围:': '受众范围:',
    '请录入受众范围!': '请录入受众范围!',
    '使用门槛:': '使用门槛:',
    '请录入使用门槛!': '请录入使用门槛!',
    '请录入券的最低使用门槛金额。': '请录入券的最低使用门槛金额。',
    '券面金额:': '券面金额:',
    '请录入券面金额!': '请录入券面金额!',
    '请录入券面金额。': '请录入券面金额。',
    '券有效期:': '券有效期:',
    '请录入券有效时间范围!': '请录入券有效时间范围!',
    '开始日期': '开始日期',
    '结束日期': '结束日期',
    '所有券清单': '所有券清单',
    '停用': '停用',
    '设置': '设置',
    '确定要删除当前券吗，删除后不可恢复？': '确定要删除当前券吗，删除后不可恢复？',
    '券已过期': '券已过期',
    '消费金额超过': '消费金额超过',
    '已发券清单': '已发券清单',
    '发放券': '发放券',
    '未设': '未设',
    '最近一个月未登录': '最近一个月未登录',
    '最近两个月未登录': '最近两个月未登录',
    '最近三个月未登录': '最近三个月未登录',
    '半年未登录': '半年未登录',
    '最近一个月未下单': '最近一个月未下单',
    '最近两个月未下单': '最近两个月未下单',
    '最近三个月未下单': '最近三个月未下单',
    '半年未下单': '半年未下单',
    '会员数:': '会员数:',
    '不重复发放': '不重复发放',
    '券名称': '券名称',
    '发放': '发放',
    '定向生效': '定向生效',
    '生效周期': '生效周期',
    '券面金额': '券面金额',
    '受众范围': '受众范围',
    '使用门槛': '使用门槛',
    '开始时间': '开始时间',
    '截止时间': '截止时间',
    '过期时间': '过期时间',
    '累计订单': '累计订单',
    '最后下单时间': '最后下单时间',
    '客户': '客户',
    '来源': '来源',
    '发放类型': '发放类型',
    '发生时间': '发生时间',
    '新增优惠券': '新增优惠券',
    '券类型': '券类型',
    '导出': '导出',
    '订单列表': '订单列表',
    '支付宝支付': '支付宝支付',
    '线下支付': '线下支付',
    '余额支付': '余额支付',
    '退款': '退款',
    '确定要作废这个订单吗？': '确定要作废这个订单吗？',
    '作废': '作废',
    '客户分组': '客户分组',
    '订单详情': '订单详情',
    '客户信息': '客户信息',
    '客户姓名': '客户姓名',
    '联系电话': '联系电话',
    '下单时间': '下单时间',
    '版型号': '版型号',
    '数量': '数量',
    '订单金额': '订单金额',
    '券抵扣': '券抵扣',
    '版型退款': '版型退款',
    '退款人': '退款人',
    '退款时间': '退款时间',
    '留言': '留言',
    '购买尺码': '购买尺码',
    '尺码数据': '尺码数据',
    '电话': '电话',
    '商品名称': '商品名称',
    '附件': '附件',
    '尺码': '尺码',
    '评分': '评分',
    '店面信息': '店面信息',
    '订单数量': '订单数量',
    '门店信息': '门店信息',
    '电子版型订单': '电子版型订单',
    '的订单': '的订单',
    '复制成功': '复制成功',
    '无': '无',
    '订单作废成功！': '订单作废成功！',
    '管理员版型退款': '管理员版型退款',
    '退款成功': '退款成功',
    '全部': '全部',
    '客户姓名/手机号/订单号': '客户姓名/手机号/订单号',
    '请输入款号、编码、系统编码、版型标题查询': '请输入款号、编码、系统编码、版型标题查询',
  '服装类别': '服装类别',
  '版型/定制': '版型/定制',
  '添加版型': '添加版型',
  '版型列表': '版型列表',
  '版型共享': '版型共享',
  '全选': '全选',

  '点击开通成衣量体定制': '点击开通成衣量体定制',

  '点击修改量体定制价格': '点击修改量体定制价格',
  '下载版型': '下载版型',
  '所有面料饰品': '所有面料饰品',
  '没有绑定面料或饰品': '没有绑定面料或饰品',
  '面料饰品': '面料饰品',
  '制版师机构列表': '制版师机构列表',
  '提交': '提交',
  '颜色：': '颜色：',
  '成衣定制上下架': '成衣定制上下架',
  '恢复': '恢复',
  '已删除': '已删除',
  '面料名称': '面料名称',
  '面料名称：': '面料名称：',
  '请录入面料名称!': '请录入面料名称!',
  '请引用面料  →': '请引用面料  →',
  '引用面料': '引用面料',
  '面料颜色：': '面料颜色：',
  '请引用面料': '请引用面料',
  '面料款号：': '面料款号：',
  '请录入面料款号!': '请录入面料款号!',
  '成衣定制标题：': '成衣定制标题：',
  '请录入成衣成衣定制标题!': '请录入成衣成衣定制标题!',
  '成衣生产加工费：': '成衣生产加工费：',
  '客户定制成衣价：': '客户定制成衣价：',
  '会员定制成衣价：': '会员定制成衣价：',
  '成衣定制说明：': '成衣定制说明：',
  '请录入成衣描述!': '请录入成衣描述!',
  '请在此录入成衣定制描述': '请在此录入成衣定制描述',
  '新增面料': '新增面料',
  '版型组套': '版型组套',
  '请输入版型标题，代码进行检索': '请输入版型标题，代码进行检索',
  '版型类别': '版型类别',
  '审核还未开始，暂无数据。': '审核还未开始，暂无数据。',
  '版型浏览': '版型浏览',
  '版型基本信息': '版型基本信息',
  '版型标题': '版型标题',
  '版型款号': '版型款号',
  '版型价格': '版型价格',
  '服装分类': '服装分类',
  '版型描述': '版型描述',
  '成衣描述': '成衣描述',
  '版型图片': '版型图片',
  '版型文件': '版型文件',
  '面料信息': '面料信息',
  '面料': '面料',
  '配饰信息': '配饰信息',
  '配饰': '配饰',
  '流程浏览': '流程浏览',
  '电子版型': '电子版型',
  '绑定': '绑定',
  '恢复成功': '恢复成功',
  '开通成功！': '开通成功！',
  '只有开通了成衣定制了才能上下架产品。': '只有开通了成衣定制了才能上下架产品。',
  '账号已停用或绑定错误。': '账号已停用或绑定错误。',
  '提交共享成功': '提交共享成功',
  '新面料': '新面料',
  '饰品名称:': '饰品名称:',
  '请录入饰品名称!': '请录入饰品名称!',
  '饰品颜色:': '饰品颜色:',
  '请录入饰品颜色!': '请录入饰品颜色!',
  '饰品款号:': '饰品款号:',
  '请录入饰品款号!': '请录入饰品款号!',
  '饰品类别:': '饰品类别:',
  '请选择饰品类别!': '请选择饰品类别!',
  '成本价格:': '成本价格:',
  '请录入商品成本价格!': '请录入商品成本价格!',
  '分销价格:': '分销价格:',
  '请录入商品分销价格!': '请录入商品分销价格!',
  '销售价格:': '销售价格:',
  '请录入商品销售价格!': '请录入商品销售价格!',
  '会员价格:': '会员价格:',
  '请录入商品会员价格!': '请录入商品会员价格!',
  '销售单位:': '销售单位:',
  '请录入销售单位!': '请录入销售单位!',
  '商品描述:': '商品描述:',
  '请录入商品描述!': '请录入商品描述!',
  '请在此录入商品描述': '请在此录入商品描述',
  '单击选择': '单击选择',
  '一个或多个文件上传': '一个或多个文件上传',
  '上传的文件将按文件扩展自动分类': '上传的文件将按文件扩展自动分类',
  '图片文件': '图片文件',
  '商品信息': '商品信息',
  // 2026-08-26：管理端订单详情统一显示可编辑且必填的备注/留言文案。
  '保存': '保存','备注/留言信息': '备注/留言信息','请输入备注/留言信息': '请输入备注/留言信息','备注/留言信息保存成功': '备注/留言信息保存成功',
  '审核受理中，不可编辑': '审核受理中，不可编辑',
  '已审核,不可编辑': '已审核,不可编辑',
  '保存并提交审核': '保存并提交审核',
  '解除审核': '解除审核',
  '撤销审核申请': '撤销审核申请',
  '返回': '返回',
  '解锁成功': '解锁成功',
  '撤销成功': '撤销成功',
  '撤销失败,当前状态不能被撤销。': '撤销失败,当前状态不能被撤销。',
  '当前账号没有该权限，请联系管理理员': '当前账号没有该权限，请联系管理理员',
  '图片删除成功': '图片删除成功',
  '审核通过。': '审核通过。',
  '提交成功': '提交成功',
  '饰品新增成功': '饰品新增成功',
  '饰品保存成功': '饰品保存成功',
  '请输入款号、编码、系统编码、饰品标题查询': '请输入款号、编码、系统编码、饰品标题查询',
  '商品共享': '商品共享',
  '共享': '共享',
  '不共享': '不共享',
  '饰品范围': '饰品范围',
  '所有饰品': '所有饰品',
  '上级饰品': '上级饰品',
  '本店饰品': '本店饰品',
  '批量上下架': '批量上下架',
  '查询': '查询',
  '添加饰品': '添加饰品',
  '缩图': '缩图',
  '平台编号': '平台编号',
  '款号': '款号',
  '状态': '状态',
  '标题': '标题',
  '颜色': '颜色',
  '库存数': '库存数',
  '销售价': '销售价',
  '所属门店': '所属门店',
  '上下架时间': '上下架时间',
  '最后修改人': '最后修改人',
  '操作': '操作',
  '修改上架时间': '修改上架时间',
  '确定': '确定',
  '取消': '取消',
  '待审核': '待审核',
  '已审核': '已审核',
  '已驳回': '已驳回',
  '审核中': '审核中',
  '上架平台': '上架平台',
  '未通过': '未通过',
  '下架平台': '下架平台',
  '上架': '上架',
  '下架': '下架',
  '编辑': '编辑',
  '查看': '查看',
  '删除': '删除',
  '加颜色': '加颜色',
  '设为头版': '设为头版',
  '添加饰品颜色': '添加饰品颜色',
  '饰品标题:': '饰品标题:',
  '请录入饰品标题!': '请录入饰品标题!',
  '饰品编号:': '饰品编号:',
  '饰品单位:': '饰品单位:',
  '请录入PLT文件价格!': '请录入PLT文件价格!',
  '请录入成本价格!': '请录入成本价格!',
  '请录入销售价格!': '请录入销售价格!',
  '确定删除该图片吗？': '确定删除该图片吗？',
  '请选择需要添加的版型。': '请选择需要添加的版型。',
  '审核详情': '审核详情',
  '审核尚未开始': '审核尚未开始',
  '不通过': '不通过',
  '通过': '通过',
  '原因：': '原因：',
  '审核附件': '审核附件',
  '关闭': '关闭',
  '引用': '引用',
  '标题：': '标题：',
  '请录入版型标题：!': '请录入版型标题：!',
  '销售价：': '销售价：',
  '会员价：': '会员价：',
  '分销价：': '分销价：',
  '版型说明：': '版型说明：',
  '请在入版型描述!': '请在入版型描述!',
  '请在此录入版型描述': '请在此录入版型描述',
  '更新': '更新',
  '删除商品': '删除商品',
  '您确认删除该商品吗？删除后不可恢复！！': '您确认删除该商品吗？删除后不可恢复！！',
  '请勾选需要批量上下架的产品': '请勾选需要批量上下架的产品',
  '上级店面的商品': '上级店面的商品',
  '自已创建的商品': '自已创建的商品',
  '批量上架': '批量上架',
  '批量下架': '批量下架',
  '删除成功！': '删除成功！',
  '设置封面成功。': '设置封面成功。',
  '操作成功': '操作成功',
  '面料标题:': '面料标题:',
  '请录入面料标题!': '请录入面料标题!',
  '面料颜色:': '面料颜色:',
  '请录入面料颜色!': '请录入面料颜色!',
  '面料编号:': '面料编号:',
  '面料单位:': '面料单位:',
  '请输入款号、编码、系统编码、成衣标题查询': '请输入款号、编码、系统编码、成衣标题查询',
  // 2026-08-04：补充面料搜索提示文案，避免面料管理显示成衣标题查询。
  '请输入款号、编码、系统编码、面料标题查询': '请输入款号、编码、系统编码、面料标题查询',
  '面料范围': '面料范围',
  '所有面料': '所有面料',
  '上级面料': '上级面料',
  '本店面料': '本店面料',
  '添加面料': '添加面料',
  '创建组套': '创建组套',
  '保存组套': '保存组套',
  '取消组套': '取消组套',
  '绑定成衣': '绑定成衣',
  '添加面料颜色': '添加面料颜色',
  '输入关键字查询成衣': '输入关键字查询成衣',
  '编号': '编号',
  '上架时间': '上架时间',
  '成衣组套': '成衣组套',
  '输入编号标题开始查询': '输入编号标题开始查询',
  '选择': '选择',
  '确认组套': '确认组套',
  '宽度': '宽度',
  '米': '米',
  '解套': '解套',
  '组套': '组套',
  '确认绑定': '确认绑定',
  '下一步': '下一步',
  '上一步': '上一步',
  '删除成功': '删除成功',
  '共享成功': '共享成功',
  '取消共享成功': '取消共享成功',
  '设置成功。': '设置成功。',
  '版型更新成功': '版型更新成功',
  '面料新增成功': '面料新增成功',
  '请录入正确的价格!': '请录入正确的价格!',
  '元': '元',
  '博克CAD-PLT-尺码文件': '博克CAD-PLT-尺码文件',
  '打包下载': '打包下载',
  '版型信息': '版型信息',
  '绑定面料': '绑定面料',
  '绑定配饰': '绑定配饰',
  '上传的EXCEL尺码与所选择的尺码类型不匹配': '上传的EXCEL尺码与所选择的尺码类型不匹配',
  '尺码匹配错误': '尺码匹配错误',
  '缺失': '缺失',
  '忽略': '忽略',
  '正在下载文件中，请稍后……': '正在下载文件中，请稍后……',
  '尺码更新成功': '尺码更新成功',
  '当前账号没有编辑权限，请联系管理员。': '当前账号没有编辑权限，请联系管理员。',
  '文件删除成功': '文件删除成功',
  '已存在，不能重复添加': '已存在，不能重复添加',
  '上传失败': '上传失败',
  '尺码数据匹配错误，请修改后再保存！': '尺码数据匹配错误，请修改后再保存！',
  '版型新增成功': '版型新增成功',
  '版型保存成功': '版型保存成功',
  '版型保存失败': '版型保存失败',
  '面料商:': '面料商:',
  '运单信息:': '运单信息:',
  '运单号:': '运单号:',
  '服装标题:': '服装标题:',
  '请录入服装标题!': '请录入服装标题!',
  '服装款号:': '服装款号:',
  '请录入服装编号!': '请录入服装编号!',
  'PLT文件价格:': 'PLT文件价格:',
  '版型分销价格:': '版型分销价格:',
  '服装风格:': '服装风格:',
  '服装分类:': '服装分类:',
  '尺码类型:': '尺码类型:',
  '请选择尺码表类别': '请选择尺码表类别',
  '适应季节:': '适应季节:',
  '春': '春',
  '夏': '夏',
  '秋': '秋',
  '冬': '冬',
  '版型调整视频:': '版型调整视频:',
  // 2026-08-04：补充添加成衣页面的成衣展示视频标签。
  '成衣展示视频:': '成衣展示视频:',
  '上传视频': '上传视频',
  '浏览视频': '浏览视频',
  '动态短视频:': '动态短视频:',
  '请录入动态短视频!': '请录入动态短视频!',
  '版型描述:': '版型描述:',
  '请录入录入版型描述!': '请录入录入版型描述!',
  '查看视频': '查看视频',
  '上下架': '上下架',
  '是否共享': '是否共享',
  '平台售卖': '平台售卖',
  '服装版型': '服装版型',
  '成衣定制': '成衣定制',
  '该产品处于上架中，不可删除！': '该产品处于上架中，不可删除！',
  '该产品处于共享中，不可删除！': '该产品处于共享中，不可删除！',
  '请先删除子项！': '请先删除子项！',
  '只有审核通过的产品才能上架产品。': '只有审核通过的产品才能上架产品。',
  '该产品已停止共享，暂不可上架！': '该产品已停止共享，暂不可上架！',
  '原店面已将该产品下架，暂不可上架！': '原店面已将该产品下架，暂不可上架！',
  '上架成功！': '上架成功！',
  '下架成功！': '下架成功！',
  '平台上架提交成功。': '平台上架提交成功。',
  '平台上架取消成功。': '平台上架取消成功。',
  '已完成{0}个产品的上架操作。': '已完成{0}个产品的上架操作。',
  '已完成{0}个产品的下架操作。': '已完成{0}个产品的下架操作。',
  '成组成功': '成组成功',
  '请至少勾选两个项目进行组套！': '请至少勾选两个项目进行组套！',
  '取消成组成功。': '取消成组成功。',
  '解套成功。': '解套成功。',
  '绑定成功': '绑定成功',
  '当前版型已经绑定了其它成衣，不再能再次绑定了。': '当前版型已经绑定了其它成衣，不再能再次绑定了。',
  '绑定失败': '绑定失败',
  '解绑成功': '解绑成功',
  '分类': '分类',
  '图片': '图片',
  'PLT价': 'PLT价',
  'BOKE价': 'BOKE价',
}
